export default "__VITE_ASSET__DYQAzIKR__"